import AdminFinishedEventsList from "./finishedEvents";

export default AdminFinishedEventsList;
